import { render } from "./CrHighlightedTitle.vue?vue&type=template&id=38703a00&scoped=true"
import script from "./CrHighlightedTitle.vue?vue&type=script&lang=js"
export * from "./CrHighlightedTitle.vue?vue&type=script&lang=js"

import "./CrHighlightedTitle.vue?vue&type=style&index=0&id=38703a00&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38703a00"]])

export default __exports__